import React, { useState, useEffect } from 'react';
import HowToPlayModal from './HowToPlayModal.js';
import './themeToggle.css';

const HowToPlayButton = ({ isDarkMode, showHowToPlay, gameMode }) => {
  const [isHowToPlayOpen, setIsHowToPlayOpen] = useState(showHowToPlay);
  const toggleHowToPlay = () => {
    if (isHowToPlayOpen) {
      const modeToSlug = {
        'classic': 'emoji-quiz',
        'connections': 'reel-connections'
      };
      const gameId = modeToSlug[gameMode];
      if (gameId) {
        localStorage.setItem(`howToPlayDismissed_${gameId}`, 'true');
      }
    }
    setIsHowToPlayOpen(!isHowToPlayOpen);
  };

  useEffect(() => {
    setIsHowToPlayOpen(showHowToPlay)
  }, [showHowToPlay]);

  return (
    <div>
      <button className={`mode ${isDarkMode ? 'dark' : 'light'}`} onClick={toggleHowToPlay}>
        <span className='toolbar-emoji'>🧐</span>
        <span className='toolbar-text'> How to Play</span>
      </button>
      {isHowToPlayOpen && <HowToPlayModal onClose={toggleHowToPlay} gameMode={gameMode} />}
    </div>
  );
}

export default HowToPlayButton;